<p-dialog [visible]="true" [breakpoints]="{'440px': '100%'}" [style]="{width: '40%'}" [baseZIndex]="10000"
  [modal]="true" [maximizable]="false" [draggable]="false" [resizable]="false">
  <dialog-header [title]="action ? action.name : app.translations.GBL_lbl_ActionResult" [settings]="settings" [icon]="faSquareCheck"></dialog-header>  
  <div class="row" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
    <div class="col-12 animated fadeIn padding15">
      <ng-template [ngIf]="action != undefined">
        <ng-template [ngIf]="action.confirmationPrompt">
          <div class="font14 poppins" [innerHtml]="action.confirmationPrompt"
            [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"></div>
        </ng-template>
        <ng-template [ngIf]="!action.confirmationPrompt">
          <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
            {{app.translations.CON_lbl_DefaultPrompt1}} {{action.caption}} {{app.translations.CON_lbl_DefaultPrompt2}}?
          </span>
        </ng-template>
      </ng-template>
      <ng-template [ngIf]="action == undefined">
        <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
          <div class="font14 poppins" [innerHtml]="result" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"></div>
        </span>
      </ng-template>
    </div>
  </div>
  <div class="row sticky dialog-footer-container" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
    <div class="col-12 unset-p">
      <div class="flex justify-right padding10 dialog-footer">
        <ng-template [ngIf]="action">
          <button class="btn font17" (click)="confirm()">
            <fa-icon [icon]="faCheckDouble" class="textGreen"></fa-icon>
            <span [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
              {{app.translations.GBL_btn_ConfirmText}}
            </span>
          </button>
        </ng-template>
      </div>
    </div>
  </div>
</p-dialog>
